import { render, staticRenderFns } from "./xianSeatPlan.vue?vue&type=template&id=40da5996&scoped=true&"
import script from "./xianSeatPlan.vue?vue&type=script&lang=js&"
export * from "./xianSeatPlan.vue?vue&type=script&lang=js&"
import style0 from "./xianSeatPlan.vue?vue&type=style&index=0&id=40da5996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da5996",
  null
  
)

component.options.__file = "xianSeatPlan.vue"
export default component.exports